import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { HOMEOWNERS_INSURANCE } from '@ld.consumer-portal/constants';
import { ContactCardComponent } from '../contact-card/contact-card.component';
// eslint-disable-next-line @nx/enforce-module-boundaries -- compose message is a shared feature component used in @defer block
import { ComposeMessageComponent } from '@ld.consumer-portal/documents';
import { SecureMessageCategory } from '@ld.consumer-portal/models';

@Component({
  selector: 'ld-homeowners-insurance-page',
  imports: [ContactCardComponent, MatIconModule, TranslocoPipe, ComposeMessageComponent],
  templateUrl: './homeowners-insurance-page.component.html',
  styleUrl: './homeowners-insurance-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeownersInsurancePageComponent {
  protected readonly expressInsuranceUrl = `${HOMEOWNERS_INSURANCE.websiteUrl}/${HOMEOWNERS_INSURANCE.websiteCode}`;

  protected readonly showComposeMessage = signal(false);
  protected readonly prefillCategory = SecureMessageCategory.HomeownersInsurance;
  protected readonly prefillTopic = 'Question';

  openSecureMessage(): void {
    this.showComposeMessage.set(true);
  }

  onCloseComposeMessage(): void {
    this.showComposeMessage.set(false);
  }
}
